<style lang="stylus" scoped></style>

<template>
    <span class="count-down" ref="countDown">({{ leftTime }}S)</span>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component
    export default class CountDown extends Vue {
        @Prop() duration;

        leftTime = 0;

        startCount() {
            let countTimer = setInterval(() => {
                this.leftTime--;
                if (this.leftTime <= 0) {
                    clearInterval(countTimer);
                    this.$emit("countDown");
                }
            }, 1000);
        }
        created() {
            this.leftTime = this.duration;
        }
        mounted() {
            this.startCount();
        }
        beforeDestroy() {}
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
